import { useState, useEffect } from 'react';
import { DateValue } from 'react-aria-components';
import { useLocation } from 'react-router-dom';

import { getAttendanceReservations } from '@/api/getAttendanceReservations';
import { getMonthlyAttendanceCount } from '@/api/getMonthlyAttendanceCount';
import Breadcrumbs, { BreadcrumbItem } from '@/components/Breadcrumbs/Breadcrumbs';
import { NavigationButtons } from '@/components/reservations/NavigationButtons';
import MonthlyCalendar from '@/components/reservations/visit/MonthlyCalendar';
import ReservationDetails from '@/components/reservations/visit/ReservationDetails';
import {
  MonthlyAttendanceReservationCount,
  DetailedAttendanceReservation,
} from '@/types/attendanceReservation';

export const ReservationsVisitPage = () => {
  const { pathname: pathName } = useLocation();
  const breadcrumbs: BreadcrumbItem[] = [{ path: pathName, name: '来所予約一覧' }];
  const email = localStorage.getItem('email') || '';
  const [refresh, setRefresh] = useState<boolean>(false);

  const [selectedDate, setSelectedDate] = useState<DateValue | undefined>();
  const [attendanceData, setAttendanceData] = useState<MonthlyAttendanceReservationCount[]>([]);
  const [detailedAttendanceData, setDetailedAttendanceData] = useState<
    DetailedAttendanceReservation[]
  >([]);

  const [currentMonth, setCurrentMonth] = useState<Date>(new Date());

  useEffect(() => {
    const fetchMonthlyAttendanceCount = async () => {
      const month = currentMonth.getMonth() + 1;
      const result = await getMonthlyAttendanceCount(
        email,
        currentMonth.getFullYear().toString(),
        month.toString().padStart(2, '0')
      );
      if (result.status === 200) {
        const data = result.result;

        setAttendanceData(data);
        console.log(data);
      }
    };
    fetchMonthlyAttendanceCount();
  }, [currentMonth]);

  useEffect(() => {
    if (!selectedDate) return;
    const fetchMonthlyAttendanceCount = async () => {
      const result = await getAttendanceReservations(
        email,
        `${selectedDate?.year}-${selectedDate?.month.toString().padStart(2, '0')}-${selectedDate?.day.toString().padStart(2, '0')}`
      );
      if (result.status === 200) {
        const data = result.result;

        console.log(data);
        setDetailedAttendanceData(data);
        console.log(data);
      }
    };
    fetchMonthlyAttendanceCount();
  }, [selectedDate, refresh]);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row">
        <Breadcrumbs item={breadcrumbs} />
      </div>
      <NavigationButtons />
      <div className="mt-5 flex justify-start gap-8 bg-white">
        <div className="w-[1000px] rounded-lg bg-gray-100 p-6">
          <MonthlyCalendar
            selectedDate={selectedDate!}
            setSelectedDate={setSelectedDate}
            attendanceData={attendanceData}
            currentMonth={currentMonth}
            setCurrentMonth={setCurrentMonth}
          />
        </div>
        <div className="w-[300px] flex-1 rounded-lg bg-gray-100 p-6">
          <ReservationDetails
            selectedDate={selectedDate!}
            reservations={detailedAttendanceData}
            refresh={() => {
              setRefresh(!refresh);
            }}
          />
        </div>
      </div>
    </div>
  );
};
